import { render, staticRenderFns } from "./McpDpaModal.vue?vue&type=template&id=f76731e4"
import script from "./McpDpaModal.vue?vue&type=script&lang=js"
export * from "./McpDpaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports